'use client';

import { useRouter } from 'next/navigation';
import { ComponentProps, useCallback, useMemo } from 'react';
import NavigationHeader from '@alltrails/layout/components/NavigationHeader';
import { tripPlannerSearchResultHref } from '@alltrails/layout/utils/tripPlannerEntryParams';
import useMap from '@alltrails/maps/hooks/useMap';
import useAlgoliaResultSelect from '@/hooks/useAlgoliaResultSelect';

type ExploreNavigationBaseProps = ComponentProps<typeof NavigationHeader>;

const ExploreNavigationBase = (navigationHeaderProps: ExploreNavigationBaseProps) => {
  const router = useRouter();
  const map = useMap();
  const getMapLatLng = useMemo(() => {
    if (map) {
      return () => map.getCenter();
    }
    return undefined;
  }, [map]);

  const handleResultSelect = useAlgoliaResultSelect({ navigateToPOI: true, navigateToPlace: true, navigateToTrail: true });

  // This app owns /trip-assistant, so use client side routing
  const handleTripPlannerSelect = useCallback(() => {
    router.push(tripPlannerSearchResultHref);
  }, [router]);

  return (
    <NavigationHeader
      searchClearOnSelect
      searchPreventNavigationOnSelect
      searchGetCurrentLatLng={getMapLatLng}
      searchOnResultSelect={handleResultSelect}
      searchOnTripPlannerSelect={handleTripPlannerSelect}
      {...navigationHeaderProps}
    />
  );
};

export default ExploreNavigationBase;
